// H3 (Heatic 3) effective coverage dimensions (meters) by sensor height, ceiling mount.
// Source: "Butlr Heatic Sensor Effective Coverage Calculation" spec sheet.
// X = Effective Coverage Length, Y = Effective Coverage Width.
// All values are for 120° FOV X / 80° FOV Y, ceiling mount.
const H3_COVERAGE_TABLE: { height: number; x: number; y: number }[] = [
  { height: 2.2, x: 3.74, y: 2.06 },
  { height: 2.25, x: 3.88, y: 2.14 },
  { height: 2.3, x: 4.03, y: 2.21 },
  { height: 2.35, x: 4.18, y: 2.29 },
  { height: 2.4, x: 4.33, y: 2.36 },
  { height: 2.45, x: 4.48, y: 2.44 },
  { height: 2.5, x: 4.63, y: 2.51 },
  { height: 2.55, x: 4.78, y: 2.59 },
  { height: 2.6, x: 4.93, y: 2.67 },
  { height: 2.65, x: 5.08, y: 2.74 },
  { height: 2.7, x: 5.23, y: 2.82 },
  { height: 2.75, x: 5.37, y: 2.89 },
  { height: 2.8, x: 5.52, y: 2.97 },
  { height: 2.85, x: 5.67, y: 3.04 },
  { height: 2.9, x: 5.82, y: 3.12 },
  { height: 2.95, x: 5.97, y: 3.19 },
  { height: 3.0, x: 6.12, y: 3.27 },
  { height: 3.05, x: 6.27, y: 3.34 },
  { height: 3.1, x: 6.42, y: 3.42 },
  { height: 3.15, x: 6.57, y: 3.5 },
  { height: 3.2, x: 6.71, y: 3.57 },
  { height: 3.25, x: 6.86, y: 3.65 },
  { height: 3.3, x: 7.01, y: 3.72 },
  { height: 3.35, x: 7.16, y: 3.8 },
  { height: 3.4, x: 7.31, y: 3.87 },
  { height: 3.45, x: 7.46, y: 3.95 },
  { height: 3.5, x: 7.61, y: 4.02 },
  { height: 3.55, x: 7.76, y: 4.1 },
  { height: 3.6, x: 7.91, y: 4.18 },
  { height: 3.65, x: 8.06, y: 4.25 },
  { height: 3.7, x: 8.2, y: 4.33 },
  { height: 3.75, x: 8.35, y: 4.4 },
  { height: 3.8, x: 8.5, y: 4.48 },
  { height: 3.85, x: 8.65, y: 4.55 },
  { height: 3.9, x: 8.8, y: 4.63 },
  { height: 3.95, x: 8.95, y: 4.7 },
  { height: 4.0, x: 9.1, y: 4.78 },
];

export interface H3CoverageDimensions {
  /** Effective coverage length in meters (X axis) */
  x: number;
  /** Effective coverage width in meters (Y axis) */
  y: number;
}

function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/**
 * Returns H3 coverage dimensions (in meters) for a given sensor height.
 * Uses linear interpolation between table entries.
 * Heights outside the valid range (2.2–4.0m) are clamped to edge values.
 */
export function getH3CoverageDimensions(height: number): H3CoverageDimensions {
  const first = H3_COVERAGE_TABLE[0];
  const last = H3_COVERAGE_TABLE[H3_COVERAGE_TABLE.length - 1];

  if (height <= first.height) return { x: first.x, y: first.y };
  if (height >= last.height) return { x: last.x, y: last.y };

  for (let i = 0; i < H3_COVERAGE_TABLE.length - 1; i++) {
    const lo = H3_COVERAGE_TABLE[i];
    const hi = H3_COVERAGE_TABLE[i + 1];

    if (height >= lo.height && height <= hi.height) {
      const t = lo.height === hi.height ? 0 : (height - lo.height) / (hi.height - lo.height);
      return {
        x: lerp(lo.x, hi.x, t),
        y: lerp(lo.y, hi.y, t),
      };
    }
  }

  return { x: last.x, y: last.y };
}
